import React from 'react'
import styled from 'styled-components'
import calendarImage from '../images/calendar-01.svg'
import TagList from '../components/TagList'

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: ${props => props.theme.sizes.maxWidthCentered};
`

const Date = styled.p`
  span {
    vertical-align: middle;
    margin-left: 5px;
    font-size: 15px;
    color: #babebf;
  }
  img {
    display: inline-block;
    width: 20px;
    vertical-align: middle;
    position: relative;
    top: -2px;
  }
`
const Title = styled.h1`
  font-size: 1.7em;
  font-weight: 600;
  width: 100%;
  line-height: 1.4;
  margin: 15px 0 20px;
`

const PostDate = props => {
  return (
    <Wrapper>
      <Date>
        <img src={calendarImage} alt="公開日" width="24" height="24" />
        <span className="webfont">{props.date}</span>
      </Date>
      <Title>{props.title}</Title>
      {props.tags && <TagList tags={props.tags} />}
    </Wrapper>
  )
}

export default PostDate
